import { FC, useContext, useEffect, useState } from 'react';
import { Box, List, Button, ListItem, Link, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { PureLightTheme } from 'src/theme/schemes/PureLightTheme';
import { EnrolledSubject } from 'src/models/enrolledSubject.interface';
import { apiUrls } from 'src/utils/properties';
import { useTranslation } from 'react-i18next';
import { EnrolledSubjectContext } from 'src/contexts/EnrolledSubjectsContext';
import { AssessmentScreenType } from 'src/enums';
import {
  MenuWrapper,
  SubMenuWrapper
} from 'src/components/StyledComponents/StudentLayout';

interface Props {
  handleMenuClick: () => void;
}

const SidebarMenu: FC<Props> = (props: Props) => {
  const { handleMenuClick } = props;

  const { contextEnrolledSubjects, getContextEnrolledSubjects } = useContext(
    EnrolledSubjectContext
  );

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const subjectId = searchParams.get('subjectId');

  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [isDashboardSelected, setIsDashboardSelected] = useState(true);

  useEffect(() => {
    if (subjectId) {
      setSelectedSubjectId(subjectId);
      setIsDashboardSelected(false);
    }
    getContextEnrolledSubjects();
  }, []);

  const handleSubjectClick = (
    enrolledSubject: EnrolledSubject,
    isCompletedPlacementTest: boolean
  ) => {
    handleMenuClick();
    setSelectedSubjectId(enrolledSubject?.subject_id);
    setIsDashboardSelected(false);

    if (!isCompletedPlacementTest || enrolledSubject?.activityId === null)
      navigate(
        apiUrls.STUDENT +
          apiUrls.ASSESSMENT +
          `?subjectId=${enrolledSubject?.subject_id}&type=${AssessmentScreenType.Intro}`
      );
    else if (enrolledSubject.activityId !== null)
      navigate(`/student/activity-management/${enrolledSubject?.activityId}`);
  };

  const dashboardClick = () => {
    handleMenuClick();
    setIsDashboardSelected(true);
    setSelectedSubjectId(null);

    navigate('/student/dashboard');
  };

  return (
    <>
      <MenuWrapper>
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                sx={{
                  textAlign: 'left',
                  width: '100%',
                  backgroundColor: isDashboardSelected
                    ? `${PureLightTheme.customColors.selectedMenuColor}!important`
                    : 'transparent',
                  '&:hover': {
                    backgroundColor: `${PureLightTheme.customColors.selectedMenuColor}!important`
                  }
                }}
                disableRipple
                onClick={dashboardClick}
              >
                {t('dashboard')}
              </Button>
            </ListItem>
            {contextEnrolledSubjects?.map((enrolledSubject) => {
              return (
                <ListItem component="div" key={enrolledSubject?.subject_id}>
                  <Button
                    sx={{
                      '&:hover': {
                        backgroundColor: `${PureLightTheme.customColors.selectedMenuColor}!important`
                      }
                    }}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      backgroundColor:
                        selectedSubjectId === enrolledSubject?.subject_id
                          ? PureLightTheme.customColors.selectedMenuColor
                          : 'transparent'
                    }}
                    disableRipple
                    onClick={() =>
                      handleSubjectClick(
                        enrolledSubject,
                        enrolledSubject?.enrolledSubject_isCompletedPlacementExam
                      )
                    }
                  >
                    <Box>
                      {enrolledSubject?.subject_name}
                      {!enrolledSubject?.enrolledSubject_isCompletedPlacementExam ? (
                        <Typography style={{ fontSize: '0.8rem' }}>
                          <Link color="inherit" underline="always">
                            {t('tryAssessment')}
                          </Link>
                        </Typography>
                      ) : enrolledSubject?.activityId === null ? (
                        <Typography style={{ fontSize: '0.8rem' }}>
                          <Link color="inherit" underline="always">
                            {t('pending')}
                          </Link>
                        </Typography>
                      ) : (
                        <Typography style={{ fontSize: '0.8rem' }}>
                          <Link color="inherit" underline="always">
                            {enrolledSubject?.activityName}
                          </Link>
                        </Typography>
                      )}
                    </Box>
                  </Button>
                </ListItem>
              );
            })}
          </List>
        </SubMenuWrapper>
      </MenuWrapper>
    </>
  );
};

export default SidebarMenu;
